import React, { useEffect, useRef } from 'react';
import { trackAdClick, trackAdImpression } from '../services/airtable';
import './AdBanner.css';

function AdBanner({ ad }) {
  const impressionTracked = useRef(false);

  useEffect(() => {
    // Track impression once when ad first renders
    if (ad && !impressionTracked.current) {
      impressionTracked.current = true;
      trackAdImpression(ad.id, ad.fields.Impression_Count || 0);
    }
  }, [ad]);

  if (!ad) return null;

  const imageUrl = ad.fields.Ad_Image?.[0]?.url;
  const clickUrl = ad.fields.Click_URL;
  const tagline = ad.fields.Tagline;
  const advertiser = ad.fields.Advertiser;

  if (!imageUrl) return null;

  const handleClick = (e) => {
    e.preventDefault();
    trackAdClick(ad.id, ad.fields.Click_Count || 0);
    window.open(clickUrl, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="ad-banner">
      <div className="ad-banner-label">SPONSORED CONTENT</div>
      {tagline && <div className="ad-banner-tagline">{tagline}</div>}
      <a
        href={clickUrl}
        onClick={handleClick}
        className="ad-banner-link"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          src={imageUrl}
          alt={advertiser || 'Sponsored content'}
          className="ad-banner-image"
          onError={(e) => {
            // Hide entire ad if image fails to load
            e.target.closest('.ad-banner').style.display = 'none';
          }}
        />
      </a>
    </div>
  );
}

export default AdBanner;
